<template>
  <a-drawer width="55%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-form-model-item prop="code" >
        <span slot="label" >
          <a-tooltip>
            商家编号<template slot="title">商家编号</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.code" :maxLength="32" placeholder="'请输入商家编号'" />
      </a-form-model-item>
      <a-form-model-item prop="name" >
        <span slot="label" >
          <a-tooltip>
            商家名称<template slot="title">商家名称</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.name" :maxLength="255" placeholder="'请输入商家名称'" />
      </a-form-model-item>
      <a-form-model-item prop="logo" >
        <span slot="label" >
          <a-tooltip>
            商家logo<template slot="title">商家logo</template>
          </a-tooltip>
        </span>
        <a-upload
          name="img"
          listType="picture-card"
          class="avatar-uploader"
          :multiple="false"
          :show-upload-list="false"
          :preview="handlePreview"
          :before-upload="beforeOssUpload"
          :customRequest="coverImgUpload">
          <img
            v-if="form.logo"
            :src="form.logo"
            alt="logo"
            style="height: 140px; width: 140px;"/>
          <div v-else>
            <a-icon :type="loading ? 'loading' : 'plus'"/>
            <div class="ant-upload-text">上传</div>
          </div>
        </a-upload>
      </a-form-model-item>
      <a-form-model-item prop="backgroundImg" >
        <span slot="label" >
          <a-tooltip>
            商家背景图<template slot="title">商家背景图</template>
          </a-tooltip>
        </span>
        <a-upload
          name="backgroundImg"
          listType="picture-card"
          class="avatar-uploader"
          :multiple="false"
          :show-upload-list="false"
          :preview="handlePreview"
          :before-upload="beforeOssUpload"
          :customRequest="coverBackgroundImgUpload">
          <img
            v-if="form.backgroundImg"
            :src="form.backgroundImg"
            alt="backgroundImg"
            style="height: 140px; width: 140px;"/>
          <div v-else>
            <a-icon :type="loading ? 'loading' : 'plus'"/>
            <div class="ant-upload-text">上传</div>
          </div>
        </a-upload>
      </a-form-model-item>
      <a-form-model-item prop="floorId">
        <span slot="label">
          <a-tooltip>楼栋楼层<template slot="title">楼栋楼层</template></a-tooltip>
        </span>
        <a-cascader :options="buildingList"
                    :field-names="{ label: 'name', value: 'id', children: 'children'}"
                    placeholder="请输入楼栋楼层"
                    style="width: 100%" v-model="companyLocationSelected" allowClear @change="onCompanyLocationChange">
        </a-cascader>
      </a-form-model-item>
      <a-form-model-item prop="address">
        <span slot="label">
          <a-tooltip>详细地址<template slot="title">详细地址</template></a-tooltip>
        </span>
        <div id="amap" style="height: 450px;">
          <merchant-map ref="merchantMap" @updateLocationMap="updateLocationMap"   style="height: 100%;" />
        </div>
      </a-form-model-item>
      <a-form-model-item prop="longitude">
        <span slot="label">
          <a-tooltip>经度<template slot="title">经度</template></a-tooltip>
        </span>
        <a-input v-model="form.longitude" :maxLength="32" />
      </a-form-model-item>
      <a-form-model-item prop="latitude">
        <span slot="label">
          <a-tooltip>纬度<template slot="title">纬度</template></a-tooltip>
        </span>
        <a-input v-model="form.latitude" :maxLength="32" />
      </a-form-model-item>
      <a-form-model-item prop="brand" >
        <span slot="label" >
          <a-tooltip>
            品牌名称<template slot="title">品牌名称</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.brand" :maxLength="32" placeholder="'请输入品牌名称'" />
      </a-form-model-item>
      <a-form-model-item prop="businessHours" >
        <span slot="label" >
          <a-tooltip>
            营业时间<template slot="title">营业时间</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.businessHours" :maxLength="32" placeholder="'请输入营业时间'" />
      </a-form-model-item>
      <a-form-model-item prop="categoryId" >
        <span slot="label" >
          <a-tooltip>
            经营分类<template slot="title">经营分类</template>
          </a-tooltip>
        </span>
        <a-select v-model="form.categoryId" placeholder="'请输入经营分类'" >
          <a-select-option v-for="(item, index) in this.businessCateList" :value="item.id" :key="index">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item prop="customerServiceMobile" >
        <span slot="label" >
          <a-tooltip>
            客服电话<template slot="title">客服电话</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.customerServiceMobile" :maxLength="32" placeholder="'请输入客服电话'" />
      </a-form-model-item>
      <a-form-model-item prop="description" >
        <span slot="label" >
          <a-tooltip>
            商家简介<template slot="title">商家简介</template>
          </a-tooltip>
        </span>
        <editor v-model="form.description" placeholder="请输入商家简介" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getMallStore, addMallStore, updateMallStore } from '@/api/store/mallStore'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import Editor from "@/components/Editor/Editor.vue";
import {listBusinessCategory} from "@/api/business/businessCategory";
import {fileUpload} from "@/api/tool/common";
import {generateFilePath} from "@/api/tool/alioss";
import {cityListTree} from "@/api/logistics";
import MerchantMap from '@/views/common/map.vue'
import {pageBuildingFloor} from "@/api/building/buildingFloor";



export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    Editor,
    CustomDictTag,
    MerchantMap
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      areaList: [],
      businessCateList: [],
      buildingList: [],

      industryList: [],
      companyLocationSelected: [],

      // 表单参数
      form: {
        id: null,
        code: null,
        name: null,
        logo: null,
        backgroundImg: null,
        floorId: null,
        buildingId: null,
        address: null,
        merchantStatus: 0,
        description: null,
        brand: null,
        longitude: null,
        latitude: null,
        categoryId: null,
        customerServiceMobile: null,
        businessHours: null,
        createTime: null,
        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        name: [
          { required: true, message: '商家名称不能为空', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '商家编号不能为空', trigger: 'blur' }
        ],
        logo: [
          { required: true, message: '商家logo不能为空', trigger: 'blur' }
        ],
        backgroundImg: [
          { required: true, message: '商家背景图不能为空', trigger: 'blur' }
        ],
        floorId: [
          { required: true, message: '商家地区不能为空', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '详细地区不能为空', trigger: 'blur' }
        ],
        merchantStatus: [
          { required: true, message: '商家状态不能为空', trigger: 'blur' }
        ],
        brand: [
          { required: true, message: '品牌不能为空', trigger: 'change' }
        ],
        categoryId: [
          { required: true, message: '经营分类不能为空', trigger: 'blur' }
        ],
        customerServiceMobile: [
          { required: true, message: '客服电话不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
    this.getBusinessCate()
    this.getBuilding()

  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        code: null,
        name: null,
        logo: null,
        backgroundImg: null,
        floorId: null,
        buildingId: null,
        address: null,
        merchantStatus: 0,
        description: null,
        brand: null,
        longitude: null,
        latitude: null,
        industryId: null,
        categoryId: null,
        customerServiceMobile: null,
        businessHours: null,
        createTime: null,
        remark: null,
      }
      this.companyLocationSelected = []
    },
    initMap(){
      let longitude = this.form.longitude
      let latitude = this.form.latitude
      let areac = this.form.floorId.substring(0, 4) + '00'
      let detailedAddress = this.form.address
      this.$refs.merchantMap.initMarker(longitude, latitude, areac, detailedAddress);
    },
    updateLocationMap(data) {
      console.log('地图选点',data)
      this.form.latitude = data.lat
      this.form.longitude = data.lon
      this.form.address=data.orgAddr
    },
    // oss 上传开始
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await this.getBase64(file.originFileObj)
      }
      this.previewImage = file.url || file.preview
      this.previewVisible = true
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      })
    },
    // 上传之前校验
    beforeOssUpload(file) {
      // const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 20
      // if (!isJPG) {
      //     this.$message.error('上传头像图片只能是 JPG 格式!');
      // }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 20MB!')
      }
      return isLt2M
    },
    // 上传覆盖默认的上传行为
    coverImgUpload(file, index) {
      const _this = this
      // 获取文件对象
      const uploadFile = file.file
      // 文件夹目录
      const prefix = 'advert'
      const url = _this.uploadAliYunOss(uploadFile.name, prefix)
      /*_this.$nextTick(() => {
        uploadObject(url, uploadFile).then(res => {
          _this.form.masterImg = res
          _this.$message.success('上传成功')
        })
      })*/
      const formData = new FormData()
      formData.append('file', uploadFile, url)
      _this.$nextTick(() => {
        fileUpload(formData).then(res => {
          _this.form.logo = res.data.fullPath
          _this.$message.success('上传成功')
        })
      })
    },

    coverBackgroundImgUpload(file, index) {
      const _this = this
      // 获取文件对象
      const uploadFile = file.file
      // 文件夹目录
      const prefix = 'advert'
      const url = _this.uploadAliYunOss(uploadFile.name, prefix)
      /*_this.$nextTick(() => {
        uploadObject(url, uploadFile).then(res => {
          _this.form.masterImg = res
          _this.$message.success('上传成功')
        })
      })*/
      const formData = new FormData()
      formData.append('file', uploadFile, url)
      _this.$nextTick(() => {
        fileUpload(formData).then(res => {
          _this.form.backgroundImg = res.data.fullPath
          _this.$message.success('上传成功')
        })
      })
    },
    /**
     * 文件上传到oss返回url地址
     * @param { file } 文件对象
     */
    uploadAliYunOss(fileName, prefix) {
      // 获取文件后缀
      const suffix = fileName.substring(fileName.lastIndexOf('.'))
      // 生成文件名称
      const filePath = generateFilePath(prefix, suffix)
      return filePath
    },
    // oss 上传结束

    getAreaTree() {
      cityListTree().then(response => {
        this.areaList = response.data
      })
    },

    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'

    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getMallStore({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.companyLocationSelected.push(this.form.buildingId);
        this.companyLocationSelected.push(this.form.floorId);
        this.formTitle = '修改'
        this.$nextTick(()=>{
          this.initMap()
        })
      })
    },
    getBusinessCate() {
      listBusinessCategory({}).then(response => {
        this.businessCateList = response.data
      })
    },
    getBuilding() {
      pageBuildingFloor({"pageNum":1,"pageSize":1000}).then(response => {
        this.buildingList = response.data.records
      })
    },
    /*省市区的选择*/
    onCompanyLocationChange(value, selectedOptions) {
      this.form.floorId = value[1]
      this.form.buildingId = value[0]

    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = '修改成功'
            updateMallStore(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message ='添加成功'
            addMallStore(this.form).then(response => {
              this.$message.success(message, 3)
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
